import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { AuthService } from "src/services/auth.service";

@Injectable({
    providedIn: 'root'
})

export class AddExemptionBookGuard  {
    constructor(private router: Router,private cookieService: CookieService,private authService:AuthService) { }
   
    canActivate() {
      const token = this.authService.getToken();
      const role = this.authService.getRole();
      const name = this.authService.getNationalNumber();

      if (token) {
        
        if(role?.includes('ADMIN_ENTITY') && role?.includes('MANAGER') && name?.toLocaleLowerCase() === 'mohammed.al-omari@moin.gov.jo'){
          return true;
        }else{
          this.router.navigate(['/']);
          return false;
        }
      } else {
        // Token is missing, user is not authorized to access the requested route
        this.router.navigate(['/']);
        return false;
      }
    }
  }
  